import { Component } from '@angular/core';
import * as Highcharts from 'highcharts';
import { MeteogramData } from '../shared/models/meteogram-data.model';

@Component({
  selector: 'app-meteogram',
  templateUrl: './meteogram.component.html'
})

export class MeteogramComponent {
  draw(data: MeteogramData): void {
    Highcharts.chart('meteogram', {
      chart: {
        type: 'column'
      },
      credits: {
        enabled: false
      },
      title: {
        text: this.getLocation(data.location)
      },
      subtitle: {
        text: ''
      },
      xAxis: [{
        categories: this.getCategories(data.categories),
        crosshair: true,
        offset: 40
      }],
      yAxis: [{ // Primary yAxis
        labels: {
          format: '{value} °C',
          style: {
            color: '#ee5253'
          }
        },
        title: {
          text: ''
        }
      }, { // Secondary yAxis
        labels: {
          format: '{value} mm',
          style: {
            color: '#54a0ff'
          }
        },
        title: {
          text: ''
        },
        opposite: true
      }],
      tooltip: {
        borderWidth: 0,
        shared: true
      },
      legend: {
        align: 'left',
        verticalAlign: 'top',
        layout: 'vertical',
        x: 60,
        y: 54,
        floating: true
      },
      series: [{
        name: 'Temperature',
        type: 'spline',
        color: '#ee5253',
        data: this.getTemperatures(data.temperatures),
        tooltip: {
          valueSuffix: ' °C'
        },
        showInLegend: false,
        zIndex: 2
      }, {
        name: 'Rainfall',
        type: 'column',
        color: '#54a0ff',
        yAxis: 1,
        data: this.getRainfalls(data.rainfalls),
        tooltip: {
          valueSuffix: ' mm'
        },
        showInLegend: false,
      }, {
        name: 'Wind',
        type: 'windbarb',
        color: '#2c3e50',
        data: this.getWinds(data.winds),
        tooltip: {
          valueSuffix: ' m/s',
        },
        showInLegend: false
      }]
    });
  }

  private getLocation(location: string): string {
    if (location === '') {
      return 'Location not set';
    } else {
      return 'Weather in ' + location;
    }
  }

  private getCategories(categories: string[]): string[] {
    if (categories.length === 0) {
      return [''];
    } else {
      return categories;
    }
  }

  private getTemperatures(temperatures: number[]): number[] {
    if (temperatures.length === 0) {
      return [0];
    } else {
      return temperatures;
    }
  }

  private getRainfalls(rainfalls: number[]): number[] {
    if (rainfalls.length === 0) {
      return [0];
    } else {
      return rainfalls;
    }
  }

  private getWinds(winds: number[][]): number[][] {
    if (winds.length === 0) {
      return [[0, 0]];
    } else {
      return winds;
    }
  }
}
